import { render } from "./p-draggable.vue?vue&type=template&id=00b61ff0&scoped=true"
import script from "./p-draggable.vue?vue&type=script&lang=js"
export * from "./p-draggable.vue?vue&type=script&lang=js"

import "./p-draggable.vue?vue&type=style&index=0&id=00b61ff0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00b61ff0"]])

export default __exports__